import { SocialBillingUnbilledWorksWidgetStore } from './social-billing-unbilled-works-widget.store';
import { Component, effect, HostBinding, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { unbilledWorksFrag } from './social-billing-unbilled-works-widget.query';
import { CardComponent } from '../../../kit/card/card.component';
import { LinkButtonComponent } from '../../../kit/button/link-button.component';
import { WorkGridItemObject } from '@it2go/types';
import { router } from '../../../../modules/shared/shared.global-service';
import { workUri } from '../../../../utils/router.utils';

@Component({
    selector: 'app-social-billing-unbilled-works-widget',
    templateUrl: './social-billing-unbilled-works-widget.component.html',
    styleUrl: './social-billing-unbilled-works-widget.component.scss',
    providers: [SocialBillingUnbilledWorksWidgetStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslatePipe,
        CardComponent,
        LinkButtonComponent,
    ],
})
export class SocialBillingUnbilledWorksWidgetComponent {

    public readonly store = inject(SocialBillingUnbilledWorksWidgetStore);

    protected readonly prefix = 'socialBilling.unbilledWork.';

    public folderId = input.required<number, number | string>({ transform: v => Number(v) });

    @HostBinding('style.display')
    get display(): string {
        return (this.store.data.getBilledOfferUnbilledCount()?.totalCount || 0) > 0 ? '' : 'none';
    }

    constructor() {
        effect(() => {
            this.reload();
        });
    }

    public reload(): void {
        this.store.api.getBilledOfferUnbilledCount({ folderId: this.folderId() }, unbilledWorksFrag);
    }

    protected goToWork(work?: WorkGridItemObject): void {
        if (!work) return;
        router.navigateByUrl(workUri(work.parentWork || work));
    }

}
